import React from 'react';
import './index.css';

const Switch = (props) => {
  const {
    name,
    id,
    onChange,
    value,
    onBlur,
    checked,
    hideLabel = false,
    onLabel = 'YES',
    offLabel = 'NO',
  } = props;

  return (
    <div>
      <label className="switch">
        <input
          type="checkbox"
          name={name}
          id={id}
          value={!!value}
          checked={!!checked}
          onBlur={onBlur}
          onChange={onChange}
          autoComplete="off"
        />
        <div className="slider round">
          {!hideLabel && (
            <>
              <span className="on">{onLabel}</span>
              <span className="off">{offLabel}</span>
            </>
          )}
        </div>
      </label>
    </div>
  );
};

export default Switch;
